import cn from "classnames";

import styles from "./color-picker.module.scss";

const COLORS = [
  { hex: "#86b5c4", name: "Sky blue" },
  { hex: "#cfb979", name: "Honey" },
  { hex: "#d4a18c", name: "Coral" },
  { hex: "#a4accc", name: "Periwinkle" },
  { hex: "#c99cad", name: "Rose" },
  { hex: "#d0aa81", name: "Apricot" },
  { hex: "#b6accd", name: "Lavender" },
  { hex: "#98b493", name: "Sage" },
];

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

export function ColorPicker({ value, onChange }: ColorPickerProps) {
  const options = COLORS.some((color) => color.hex === value)
    ? COLORS
    : [...COLORS, { hex: value, name: "Custom color" }];
  return (
    <div className={styles.grid} role="radiogroup" aria-label="Choose color">
      {options.map(({ hex, name }) => (
        <button
          key={hex}
          type="button"
          className={cn(styles.swatch, value === hex && styles.selected)}
          style={{ backgroundColor: hex }}
          onClick={() => onChange(hex)}
          role="radio"
          aria-checked={value === hex}
          aria-label={name}
        />
      ))}
    </div>
  );
}
